import block1 from '../assets/block1.webp'
import block2 from '../assets/block2.webp'
import type { FinaleKind } from '../game/types.ts'
import { t } from '../i18n/translations.ts'

interface Props {
  winnerColor: 'black' | 'white'
  playerColor: 'black' | 'white'
  kind: FinaleKind
}

const ICON_BY_COLOR: Record<'black' | 'white', string> = {
  black: block1,
  white: block2,
}

// 勝者宣言オーバーレイ。finale フェーズの announce ステップで表示される。
// ボード上のバウンド/キラキラ演出と同時に重なり、既定時間後に result へ遷移する。
export function FinaleOverlay({ winnerColor, playerColor, kind }: Props) {
  const playerWon = winnerColor === playerColor
  const title = playerWon ? t('finalePlayerWin') : t('finaleCpuWin')
  const subtitle = kind === 'win' ? t('finaleFive') : t('finaleTerritory')

  return (
    <div className="finale-overlay">
      <div
        className={`finale-overlay__card finale-overlay__card--${
          playerWon ? 'win' : 'lose'
        }`}
      >
        <img
          src={ICON_BY_COLOR[winnerColor]}
          alt={t('winnerAlt')}
          className="finale-overlay__piece"
        />
        <div className="finale-overlay__title">{title}</div>
        <div className="finale-overlay__sub">{subtitle}</div>
      </div>
    </div>
  )
}
